module.exports = __webpack_public_path__ + "static/media/catering.107d652e.svg";